export enum ExceptionEnum {
  DOMAIN_VALIDATION = 'DomainValidationException',
  USER_NOT_FOUND = 'CS_UserNotFoundException',
  USER_ALREADY_EXISTS = 'UserAlreadyExistsException',
  INVALID_CREDENTIALS = 'InvalidCredentialsException',
  UNAUTHORIZED_ACCESS = 'UnauthorizedAccessException',
  FORBIDDEN_ACCESS = 'ForbiddenAccessException',
  RESOURCE_NOT_FOUND = 'ResourceNotFoundException',
  INTERNAL_SERVER_ERROR = 'InternalServerErrorException',
  BAD_REQUEST = 'BadRequestException',
  CONFLICT = 'ConflictException',
  NOT_IMPLEMENTED = 'NotImplementedException',
  TENANT_NOT_FOUND = 'TenantNotFoundException',
  TENANT_ALREADY_EXISTS = 'TenantAlreadyExistsException',
  TENANT_IS_INACTIVE = 'TenantIsInactiveException',
  TENANT_FORBIDDEN_ACCESS = 'TenantForbiddenAccessException',
  INVALID_BODY_REQUEST = 'InvalidBodyRequestException',
  AWS_COGNITO_NOT_AUTHORIZED = 'NotAuthorizedException',
  AWS_COGNITO_USER_NOT_FOUND = 'UserNotFoundException',
  AWS_COGNITO_USERNAME_EXISTS = 'UsernameExistsException',
  AWS_COGNITO_CODE_MISMATCH = 'CodeMismatchException',
  AWS_COGNITO_EXPIRED_CODE = 'ExpiredCodeException',
  AWS_COGNITO_INVALID_PARAMETER = 'InvalidParameterException',
  AWS_COGNITO_INVALID_PASSWORD = 'InvalidPasswordException',
  AWS_COGNITO_USER_NOT_CONFIRMED = 'UserNotConfirmedException',
  AWS_COGNITO_LIMIT_EXCEEDED = 'LimitExceededException',
  CANNOT_RESET_ADMIN_PASSWORD = 'CannotResetAdminPasswordException',
  CONTRACT_TEMPLATE_NOT_FOUND = 'CS_ContractTemplateNotFoundException',
  CONTRACT_TEMPLATE_INVALID_FILE = 'CS_ContractTemplateInvalidFileException',
  CONTRACT_ANALYSIS_FAILED = 'CS_ContractAnalysisFailedException',
  CONTRACT_NOT_FOUND = 'CS_ContractNotFoundException',
  CONTRACT_MISSING_VARIABLES = 'CS_ContractMissingVariablesException',
  CONTRACT_RENDER_FAILED = 'CS_ContractRenderFailedException',
  CONTRACT_INVALID_STATUS_TRANSITION = 'CS_ContractInvalidStatusTransitionException',
  CONTRACT_SIGNED_FILE_TOO_LARGE = 'CS_ContractSignedFileTooLargeException',
  CONTRACT_TEMPLATE_NOT_TAGGED = 'CS_ContractTemplateNotTaggedException',
  CONTRACTOR_NOT_FOUND = 'CS_ContractorNotFoundException',
  LEAD_LEGAL_INFO_NOT_FOUND = 'CS_LeadLegalInfoNotFoundException',
}
